export class UpdateOrganizationIdpGroupRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerGroupId",
            "baseName": "providerGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleGrants",
            "baseName": "roleGrants",
            "type": "Array<OrganizationRoleGrant>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateOrganizationIdpGroupRequest.attributeTypeMap;
    }
    constructor() {
    }
}
